import clsx from 'clsx';
import { useTheme } from 'next-themes';
import type { FC } from 'react';

import { FYDEOS_NOTES_LOGO } from '../product-brand';
import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  const { resolvedTheme } = useTheme();

  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p>
        <img
          className="logo"
          src={
            resolvedTheme === 'dark'
              ? FYDEOS_NOTES_LOGO.dark
              : FYDEOS_NOTES_LOGO.light
          }
          alt="FydeOS Notes"
        />
        {title}
      </p>
      <p>{subTitle}</p>
    </div>
  );
};
